var app = angular.module("leonardo");

var SectorStates = function($stateProvider) {
  $stateProvider.state('sectors', {
    url: "/sectors",
    parent: 'authenticated.layout-main',
    title: 'Sectors list',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'sectors.list'
  });
  $stateProvider.state('sectors.list', {
    url: "/list",
    title: 'Sectors list',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/sector/list.html',
        controller: 'AdminSectorListController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/sector-list.html',
        controller: 'SectorListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Sectors List'
    }
  });
  $stateProvider.state('sectors.groups', {
    url: "/groups",
    title: 'Field groups management',
    cssClass: 'page-groups',
    views: {
      'filters@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/fields/group-list.html'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/group-list.html',
        controller: 'GroupListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Field groups management'
    }
  });
  $stateProvider.state('sectors.subgroups', {
    url: "/subgroups",
    title: 'Subgroups management',
    cssClass: 'page-subgroups',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'FieldListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/fields/list.html'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/subgroup-list.html',
        controller: 'SubgroupListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Subgroups management'
    }
  });
};

app.config(['$stateProvider', SectorStates]);
